import { useMutation } from "@tanstack/react-query";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import * as api from "@/api/returns";
import { Button } from "@/components/ui/button";

export function NewSessionPage(): React.ReactElement {
  const navigate = useNavigate();
  const [serverError, setServerError] = useState<string | null>(null);

  const createMut = useMutation({
    mutationFn: api.createSession,
    onSuccess: (s) => navigate(`/returns/sessions/${s.id}`, { replace: true }),
    onError: (e: { response?: { data?: { detail?: string } }; message?: string }) => {
      setServerError(e.response?.data?.detail ?? "Ошибка создания");
    },
  });

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-bold">Новая приёмка — маркетплейс</h1>
      <div className="grid gap-3">
        {/* Кнопки из ОБЩЕГО списка: новый маркетплейс появляется здесь сам,
            а не забывается при добавлении в белый список бэкенда. */}
        {api.MARKETPLACE_ORDER.map((mp, i) => (
          <Button
            key={mp}
            size="xl"
            variant={i === 0 ? "default" : "outline"}
            className="h-20 text-base"
            onClick={() => createMut.mutate(mp)}
            disabled={createMut.isPending}
          >
            {api.MARKETPLACE_TITLES[mp]}
          </Button>
        ))}
      </div>
      {serverError && <p className="text-sm text-destructive">{serverError}</p>}
    </div>
  );
}
